import { render, staticRenderFns } from "./SelectItemRecursive.vue?vue&type=template&id=eb4137e4&scoped=true&"
import script from "./SelectItemRecursive.vue?vue&type=script&lang=ts&"
export * from "./SelectItemRecursive.vue?vue&type=script&lang=ts&"
import style0 from "./SelectItemRecursive.vue?vue&type=style&index=0&id=eb4137e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb4137e4",
  null
  
)

export default component.exports